module.exports = __webpack_public_path__ + "img/referto-1.7fa531de.webp";